/** @format */

import React from 'react';
import I18n from '../../Translate/I18n';

interface CardBoxTitleInterface {
    classes: any;
    title: string;
}

const CardBoxTitle = (props: CardBoxTitleInterface): React.ReactElement => {
    return (
        <div className={props.classes.cardBoxTitle}>
            <I18n trans={props.title} />
        </div>
    );
};

export default CardBoxTitle;
